const Inspecciones = [
    {
        color: '#27AE60',
        name: 'Completadas',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#F2C94C',
        name: 'Por cerrar',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#F2994A',
        name: 'En proceso',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#DE4343',
        name: 'Asignar',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#161616',
        name: 'Origen',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    }
]

const Mantenciones = [
    {
        color: '#27AE60',
        name: 'Completadas',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#F2C94C',
        name: 'Por cerrar',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#F2994A',
        name: 'En proceso',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#DE4343',
        name: 'Asignar',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    },
    {
        color: '#161616',
        name: 'Origen',
        button: 'Detalle',
        buttonColor: '#F9F9F9',
        number: null
    }
]

export {
    Inspecciones,
    Mantenciones
}
